import { Fluent, PropertyGrid } from "@serenity-is/corelib";

PropertyGrid.prototype["renderContents"] = (function(org) {
    return function(this: PropertyGrid<any>) {
        const result = org.call(this);
        setTimeout(() => disableAutoComplete(this.domNode?.closest("form")), 0);
        return result;
    }
})(PropertyGrid.prototype["renderContents"]);

function disableAutoComplete(form: HTMLFormElement) {
    if (!form)
        return;

    if (!form.hasAttribute("autocomplete"))
        form.autocomplete = "off";

    if (!form.hasAttribute("aria-autocomplete"))
        form.ariaAutoComplete = "none";

    form.querySelectorAll(Fluent.inputLikeSelector).forEach((input: HTMLInputElement) => {
        if (input.type == "hidden")
            return;
        if (!input.hasAttribute("autocomplete"))
            input.autocomplete = "off";

        if (!input.hasAttribute("aria-autocomplete"))
            input.ariaAutoComplete = "none";
    });
}